//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

/**
 * Validates if a teamspace name is valid.
 * Filters out invalid values like:
 * - Empty strings
 * - The literal string "true" or "false" (boolean conversion artifacts)
 * - Null or undefined values
 * - Non-string values
 *
 * @param name - The teamspace name to validate
 * @returns true if the name is valid, false otherwise
 */
export const isValidTeamspaceName = (name: any): boolean => {
  // Check if name is a string
  if (typeof name !== 'string') {
    return false;
  }

  // Check if empty string
  if (name.trim() === '') {
    return false;
  }

  // Filter out boolean string artifacts
  if (name.toLowerCase() === 'true' || name.toLowerCase() === 'false') {
    return false;
  }

  return true;
};

/**
 * Filters an array of teamspace names to remove invalid entries
 * @param teamspaces - Array of teamspace names to filter
 * @returns Filtered array of valid teamspace names
 */
export const filterValidTeamspaceNames = (teamspaces: any[]): string[] => {
  if (!Array.isArray(teamspaces)) {
    return [];
  }

  return teamspaces.filter(isValidTeamspaceName);
};
